import { render, staticRenderFns } from "./EditWeightModal.vue?vue&type=template&id=f67e6ea0&"
import script from "./EditWeightModal.vue?vue&type=script&lang=js&"
export * from "./EditWeightModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditWeightModal.vue"
export default component.exports